import { ITEM_LINE_HEIGHT } from '../../common/constants.tsx';

export const CONTEXT_MENU_PLACEHOLDER_TESTID = 'software-context-menu.ui.menu-renderer-placeholder';

export const SEPARATOR_PLACEHOLDER_HEIGHT = 9;
export const SECTION_HEADER_PLACEHOLDER_HEIGHT = 16;
export const MENU_ITEM_PLACEHOLDER_HEIGHT = ITEM_LINE_HEIGHT;
